import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertySteps } from '../../../../../../enums/property-steps.enum';
import { AboutYouSteps } from '../../../../../../enums/about-you-steps.enum';
import { StepSection } from '../../../../../../enums/step-section.enum';
import { AddressValidationService } from '../../../../../../services/address-validation.service';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { StepperContextService } from '../../../../../../services/stepper-context.service';
import { StepperTasksService } from '../../../../../../services/stepper-tasks.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';

export enum PreviousOwnershipOptions {
  Yes = 'Yes',
  No = 'No'
}

@Component({
  selector: 'lgv-previous-ownership',
  standalone: true,
  imports: [CommonModule,
    MatDividerModule, MatButtonModule
  ],
  templateUrl: './previous-ownership.component.html',
  styleUrls: ['./previous-ownership.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviousOwnershipComponent {
  PreviousOwnershipOptions = PreviousOwnershipOptions
  isDialog = this.contextService.isDialog
  optionSelected = this.answerService.getAnswer(PropertySteps.PreviousOwnership) ?? ''

  @Output() stepChange = new EventEmitter<any>();
  @Output() sectionChange = new EventEmitter<any>();

  private yesTasks: string[] = [
    "Mortgage Statement(s)",
    "Homeowner's Insurance",
    "Homeowner's Association statement"
  ];

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    public taskService: StepperTasksService,
    public addressService: AddressValidationService
  ) { }

  ngOnInit(): void {
    this.syncTasksWithAnswer(this.optionSelected);
  }

  onAnswerSelected(ans: string) {
    this.optionSelected = ans
  }

  onNext() {
    this.answerService.setAnswer(PropertySteps.PreviousOwnership, this.optionSelected)
    this.clearAllTasks();
    this.syncTasksWithAnswer(this.optionSelected);
    this.goToStep(PropertySteps.PurchaseSubjectAddress)
  }

  onBack() {
    this.answerService.setAnswer(PropertySteps.PreviousOwnership, this.optionSelected)
    this.clearAllTasks();
    this.goToSection(StepSection.AboutYou, AboutYouSteps.BorrowerOwnership);
  }

  goToStep(step) {
    this.stepChange.emit(step);
  }

  goToSection(section, step) {
    this.sectionChange.emit([section, step]);
  }

  isBtnSelected(option: string) {
    if (option === this.optionSelected) {
      return true
    }
  }

  isNextDisabled(): boolean {
    if (this.optionSelected === '') {
      return true
    }
    return false
  }

  private clearAllTasks(): void {
    [...this.yesTasks,]
      .forEach(task => this.taskService.removeTask(task));
  }

  private syncTasksWithAnswer(answer: string): void {
    switch (answer) {
      case PreviousOwnershipOptions.Yes:
        this.yesTasks.forEach(task => this.taskService.addTask(task));
        break;
    }
  }

}
